import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

export const useGetUsStates = ({ enabled }: { enabled: boolean }) => {
  const client = useApiClient();

  return useQuery("getUsStates", () => client.getUsStates(), { enabled });
};
